// PasswordChangedSuccess.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';

const PasswordChangedSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth(); // ✅ Get the auth instance here
    signOut(auth)
      .then(() => {
        console.log('Signed out after password change');
      })
      .catch((error) => {
        console.error('Sign out error:', error);
      });
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4 shadow bg-white rounded" style={{ maxWidth: '400px' }}>
        <h3 className="mb-3 text-success fw-bold">✅ Password Changed Successfully</h3>
        <p>You have been signed out for security reasons.</p>
        <button
          className="btn btn-primary fw-bold mt-3"
          onClick={() => navigate('/login')}
        >
          Login Again
        </button>
      </div>
    </div>
  );
};

export default PasswordChangedSuccess;
